<template>
  <div class="container container-fixed-lg p-t-20">
    <div class=" no-padding p-b-20 bg-white">
      <div class="container">
        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.entity') }}</label>
          <div class="col-md-6">
            <span>{{ offer.entity.name }}</span>
          </div>
        </div>

        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.period') }}</label>
          <div class="col-md-9">
            <div v-for="(period,index) in offer.offer_periods_attributes">
              <div class="row">
                <div class="col-md-6" v-bind:class="displaySeparator(period) ? 'separator offer-period' : ''">
                  <div v-if="displayHistorical()">
                    <span v-bind:class="period.archived ? 'deleted-details' : ''">
                      {{ $t('OfferInformation.from_to', periodDateTimeParams(period.start_at, period.end_at, period.effective_work_minutes)) }}
                    </span>
                    <span v-if="period.archived" class="tag-period">{{ $t('OfferInformation.supp') }}</span>
                    <span v-else-if="period.archived_start_at == null && period.archived_effective_work_minutes == null && period.new" class="tag-period">
                      {{ $t('OfferInformation.new') }}
                    </span>
                    <div v-if="period.archived_start_at != null || period.archived_effective_work_minutes != null">
                      <span class="deleted-details deleted-details-archived">
                        <em>{{ $t('OfferInformation.from_to', periodDateTimeArchivedParams(period)) }}</em>
                      </span>
                    </div>
                  </div>

                  <span v-if="notArchived(period)">
                    {{ $t('OfferInformation.from_to', periodDateTimeParams(period.start_at, period.end_at, period.effective_work_minutes)) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr/>

        <div class="row m-t-20" v-if="entityHasHubs">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.hub_name') }}</label>
          <div class="col-md-6">
            <span>{{ offer.hub.name }}</span>
          </div>
        </div>

        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.replaced_service') }}</label>
          <div class="col-md-6">
            <span class="multiselect__tag tag-without-close">{{ offer.replaced_service.name }}</span>
          </div>
        </div>

        <hr/>

        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.replaced_occupation') }}</label>
          <div class="col-md-6">
            <span class="multiselect__tag tag-without-close">{{ offer.replaced_occupation.name }}</span>
          </div>
        </div>

        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.searched_occupations') }}
          </label>
          <div class="col-md-6">
            <span class="multiselect__tag tag-without-close m-b-0" v-for="occupation in this.offer.searched_occupations"> {{ occupation.name }}</span>
          </div>
        </div>

        <hr/>

        <div v-if="offer.replacement_detail_attributes && offer.replacement_detail_attributes.replacement_motive_name" class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.replacement_motive') }}</label>
          <div class="col-md-4">
            <span>{{ offer.replacement_detail_attributes.replacement_motive_name }}</span>
          </div>
          <div class="col-md-4" v-if="displayHistorical()" >
            <i class="pg-arrow_left" v-if="offer.replacement_detail_attributes.replacement_archived_motive_name != null"></i>
            <span class="deleted-details">{{ offer.replacement_detail_attributes.replacement_archived_motive_name }}</span>
          </div>
        </div>

        <div v-if="offer.replacement_detail_attributes && offer.replacement_detail_attributes.details" class="row m-t-20">
          <label class="col-md-3 control-label">{{  $t("models.offer.replacement_motive_detail") }}</label>
          <div class="col-md-4">
            <span>{{ offer.replacement_detail_attributes.details }}</span>
          </div>
          <div class="col-md-4" v-if=" offer.replacement_detail_attributes.archived_details != null && displayHistorical()">
            <i class="pg-arrow_left"></i>
            <span class="deleted-details">{{ offer.replacement_detail_attributes.archived_details }}</span>
          </div>
        </div>

        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.resource') }}</label>
          <div class="col-md-6">
            <span>{{ resourceName }}</span>
          </div>
        </div>

        <div v-if="offer.details" class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.details') }}</label>
          <div class="col-md-6">
            <div v-html=offer.details ></div>
          </div>
        </div>

        <hr/>

        <div class="row m-t-20">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.managers_in_copy') }}</label>
          <div class="col-md-6">
            <span>{{ offer.managers_in_copy }}</span>
          </div>
        </div>

        <hr/>

        <div class="row m-t-20" v-if="displayHistorical()">
          <label class="col-md-3 control-label">{{ $t('OfferInformation.edit_comment') }}</label>
          <div class="col-md-6">
            <span>{{ offer.edit_comment }}</span>
          </div>
        </div>

        <div v-if="hasCustomFields">
          <div class="row m-t-20" v-for="(custom_field) in offer.custom_fields">
            <label class="col-md-3 control-label">{{ custom_field.label }}:</label>
            <div class="col-md-6">
              <span>{{ custom_field.value }}</span>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { convertMinutesToDurationTime } from '@/helpers/timeCodes'

  export default {
    name: 'OfferInfomation',
    props: ['offer'],
    computed: {
      resourceName() {
        if(this.offer.resource_type != undefined){
          if(this.offer.resource_type == 'intern' &&
             this.offer.include_hub_services == true){
            return this.$i18n.t('models.offer.resources.intern_of_concerned_hub');
          }else if(this.offer.resource_type == 'intern' &&
             this.offer.include_proposed_candidates == true) {
            return this.$i18n.t('models.offer.resources.intern_with_proposed_candidates');
          }else{
            return this.$i18n.t(`models.offer.resources.${this.offer.resource_type}`);
          }
        }
      },
      entityHasHubs() {
        return this.offer.entity.hubs != undefined && this.offer.entity.hubs.length > 1;
      },
      isArchived(period) {
        if (period.archived) {
          return 'deleted-details'
        }
      },
      hasCustomFields() {
        return this.offer.custom_fields && (Object.keys(this.offer.custom_fields).length)
      }
    },
    methods: {
      periodDateTimeParams(start_at, end_at, effective_work_minutes) {
        let date = this.$options.filters.formatDate(start_at);
        let startAt = this.$options.filters.formatTime(start_at);
        let endAt = this.$options.filters.formatTime(end_at);
        let durationTime = "";

        if(effective_work_minutes && effective_work_minutes > 0){
          durationTime = "(" + convertMinutesToDurationTime(effective_work_minutes, false) + ")";
        }

        return {
          date: date,
          startAt: startAt,
          endAt: endAt,
          durationTime: durationTime
        };
      },
      periodDateTimeArchivedParams(period) {
        const {
          archived_start_at,
          archived_end_at,
          archived_effective_work_minutes,
          start_at,
          end_at,
          effective_work_minutes
        } = period;

        const date = archived_start_at ?
                    this.$options.filters.formatDate(archived_start_at) : this.$options.filters.formatDate(start_at);
        const startAt = archived_start_at ?
                        this.$options.filters.formatTime(archived_start_at) : this.$options.filters.formatTime(start_at);
        const endAt = archived_end_at ?
                      this.$options.filters.formatTime(archived_end_at) : this.$options.filters.formatTime(end_at);
        const effectiveWorkMinutes = archived_effective_work_minutes != null ? archived_effective_work_minutes : effective_work_minutes;
        const durationTime = effectiveWorkMinutes && effectiveWorkMinutes > 0 ?
                            `(${convertMinutesToDurationTime(effectiveWorkMinutes, false)})` : "";

        return { date, startAt, endAt, durationTime };
      },
      displayHistorical() {
        return this.offer.is_expired
      },
      notArchived(period) {
        return !period.archived && !this.offer.is_expired
      },
      displaySeparator(period) {
        return !period.archived || this.offer.is_expired
      }
    }
  }
</script>
<style scoped>
  .offer-data-block {
    display: -webkit-inline-box;
  }

  .offer-data-icon {
    width: 6%;
  }

  .offer-data-icon .fa {
    font-size: 20px;
  }

  .offer-data span.tag {
    display: inline-block;
    background-color: #F51153;
  }
  .offer-information {
    border-bottom: 1px solid #dadee0;
  }

  .offer-data {
    display: inherit;
    border: none !important;
  }

  .offer-period-detail {
    width: 100%;
  }

  .deleted-details {
    color: #F51153;
    text-decoration:line-through;
  }

  .tag-period {
    color: #F51153;
    background-color: #f7dfe5;
    border-radius: 8px;
    padding: 5px 10px;
    margin-left: 10px;
    font-weight: bold;
  }

  .offer-period {
    padding: 10px 0;
  }

  .separator {
    border-bottom: 0.1px solid #e1e1e2;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/OfferInformation.vue